import { render, staticRenderFns } from "./riseSecondRecord.vue?vue&type=template&id=4e2cf338&"
import script from "./riseSecondRecord.vue?vue&type=script&lang=js&"
export * from "./riseSecondRecord.vue?vue&type=script&lang=js&"
import style0 from "./riseSecondRecord.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports